import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTheme } from "@/b2b/context/ThemeContext";

export default function DateField({
  name,
  label,
  value,
  onChange,
  required,
  theme,
}) {
  const ctxTheme = useTheme();
  // Fall back to the context theme so DB-driven partners are themed even when a
  // caller forgets to pass `theme`. Avoids the hardcoded dark label background.
  const t = theme || ctxTheme;
  const isFilled = value && value !== "";

  const getTodayAtMidnight = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  return (
    <div className="relative flex flex-col h-14">
      <DatePicker
        data-clarity-unmask="false"
        selected={value ? new Date(value) : null}
        onChange={(date) => {
          if (!date) return onChange("");
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          onChange(`${yyyy}-${mm}-${dd}`);
        }}
        placeholderText={`Select ${label}`}
        minDate={getTodayAtMidnight()}
        dateFormat="dd/MM/yyyy"
        className={`custom-datepicker border-primary-500 appearance-none border ${
          t ? t.backgroundColor : "bg-input-bg"
        } p-4 border-[#A5A5A5] focus:outline-none w-full ${
          t?.textColor ? t?.textColor : "text-white"
        } focus-within:border-primary-200 h-full peer rounded-none ${
          isFilled ? "focused" : ""
        }`}
        required={required}
        onKeyDown={(e) => e.preventDefault()}
      />
      <label
        className={`absolute left-3 transition-all duration-200 text-gray-500 peer-focus:text-primary-200 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-gray-500 peer-focus:-top-2 peer-focus:text-xs peer-focus:px-1 ${
          t?.peerFocusColor || "peer-focus:bg-[#000]"
        } ${
          isFilled
            ? `text-xs -top-2 text-primary-200 ${
                t ? t.backgroundColor : "bg-[#000]"
              } px-1`
            : `text-xs -top-2 text-primary-200 ${
                t ? t.backgroundColor : "bg-[#000]"
              } px-1`
        }`}
      >
        {label}
      </label>
    </div>
  );
}

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};
